module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/material/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-tag prefix"
  }), _vm._v(" "), _c('f-category', {
    attrs: {
      "cplaceholder": "Търсене по категория"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.categories),
      callback: function($$v) {
        _vm.$set(_vm.filter, "categories", $$v)
      },
      expression: "filter.categories"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Търсене по заглавие, връзка, описание"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.fetchData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(item) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1",
      attrs: {
        "tabindex": "0"
      }
    }, [_c('router-link', {
      staticClass: "text-primary",
      attrs: {
        "to": '/material/' + item.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('c-categories', {
      attrs: {
        "value": item.categories
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-truncate",
      staticStyle: {
        "max-width": "300px"
      }
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', _vm._l((item.families), function(family) {
      return _c('c-avatar', {
        staticClass: "float-left",
        attrs: {
          "family": family
        }
      })
    })), _vm._v(" "), _c('td', {
      staticClass: "text-right pr-3"
    }, [_c('a', {
      staticClass: "btn btn-small btn-primary btn-icon",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text"
    })]), _vm._v(" "), (_vm.canEdit(item)) ? [_c('router-link', {
      staticClass: "btn btn-small btn-warning btn-icon",
      attrs: {
        "to": '/material/' + item.id + '/edit'
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-small btn-danger btn-icon m-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])] : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "143px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Заглавие")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Описание")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Семейства")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right sorting",
    staticStyle: {
      "width": "102px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Действия")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e69cf906!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/share/Materials.vue
// module id = 673
// module chunks = 1